import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord, SalesItemOptionModel } from '.';

export interface ISalesItemDiscountSalesItemModel extends IModel {
  salesItemDiscountSalesItemId: number;
  salesItemId: number;
  discountSalesItemOptionId: number;
  discountSalesItemOption: SalesItemOptionModel | undefined;
  discountSalesItemOptionFullName: string;
}
export class SalesItemDiscountSalesItemModel
  extends Model
  implements ModelRecord<ISalesItemDiscountSalesItemModel>
{
  salesItemDiscountSalesItemId: number;
  salesItemId: number;
  discountSalesItemOptionId: number;
  discountSalesItemOption: SalesItemOptionModel | undefined;
  discountSalesItemOptionFullName: string;

  constructor(params?: Partial<ISalesItemDiscountSalesItemModel>) {
    super(params);
    this.salesItemDiscountSalesItemId = defaultTo(
      params?.salesItemDiscountSalesItemId,
      0,
    );
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.discountSalesItemOptionId = defaultTo(
      params?.discountSalesItemOptionId,
      0,
    );
    this.discountSalesItemOption = params?.discountSalesItemOption
      ? new SalesItemOptionModel(params?.discountSalesItemOption)
      : undefined;
    this.discountSalesItemOptionFullName = defaultTo(
      params?.discountSalesItemOptionFullName,
      '',
    );
  }
}
